export const MANAGER_TEAM_MEMBERS_BREADCRUMBS = [
  { id: "/", name: "Home" },
  { id: "/team-members", name: "Team Members" },
];

export const teamMemberstableHeaders = ["Employee ID", "Name", "Client", "Location", "Role", "On Site Status"];

export const NO_ASSIGNED_CLIENTS_SELECT = { id: -1, value: "No Clients Assigned", disabled: true };
export const NO_ASSIGNED_LOCATIONS_SELECT = { id: -1, value: "No Locations Assigned", disabled: true };
